module.exports = __webpack_public_path__ + "static/media/whiteCog.0e989305.svg";